import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from "@angular/core";
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';
import * as FilteringActions from './filtering.actions';
import { RecognitionApiService } from 'projects/recognition/src/app/providers/api.service/recognition.api.service';

@Injectable()
export class TagSearchEffects {

  constructor(private actions$: Actions, private _recognitionApiService: RecognitionApiService) { }

  
  loadTagSearch$ = createEffect(() => this.actions$
    .pipe(
      ofType(FilteringActions.tagSearchRequested),
      mergeMap(action => this._recognitionApiService.getSearchFilterListByKeyword({ keyword: action.keyword, onlyTags: action.onlyTags })
        .pipe(
          catchError(error => {
            return of({ data: [] });
          }),
        )),
      map((result) => {
        return FilteringActions.tagSearchCompleted({ data: result?.data?.length > 0 ? result?.data : [] });
      })
    ))
}
